const fallbackMessage = 'Не удалось выполнить действие. Проверьте данные и попробуйте ещё раз';

/** Проверяет, является ли ответ объектом */
const isRecord = (value: unknown): value is Record<string, unknown> => (
    typeof value === 'object' && value !== null
);

/** Сохраняет тип ответа 400 после обработки ошибки в сервисе. */
export class BadRequestError extends Error {
    readonly status = 400;
}

/** Определяет ответ API с ошибкой в переданных данных. */
export const isBadRequestError = (error: unknown): boolean => (
    error instanceof BadRequestError
    || (isRecord(error) && isRecord(error.response) && error.response.status === 400)
);

/** Возвращает понятное сообщение для ответа API с кодом 400. */
export const getBadRequestMessage = (error: unknown): string => {
    if (error instanceof BadRequestError) return error.message;
    if (!isBadRequestError(error) || !isRecord(error)) return fallbackMessage;

    const response = error.response;

    if (!isRecord(response)) return fallbackMessage;

    if (typeof response.data === 'string') {
        const message = response.data.trim();

        return message || fallbackMessage;
    }

    if (!isRecord(response.data)) return fallbackMessage;

    const data = response.data;

    const message = typeof data.message === 'string'
        ? data.message.trim()
        : '';

    if (message) return message;

    if (isRecord(data.errors)) {
        const messages = Object.values(data.errors)
            .flatMap((value) => Array.isArray(value)
                ? value
                : [value])
            .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
            .map((value) => value.trim());

        if (messages.length > 0) return [...new Set(messages)].join('\n');
    }

    return fallbackMessage;
};
